<template>
  <ClientOnly>
    <div v-if="null === products" class="slider-loader">
      <span class="ui-loader" />
    </div>
    <ProductCarousel
      v-else
      :title="_T('@Products viewed')"
      :products="products"
    />
  </ClientOnly>
</template>

<script setup>
import ProductCarousel from "~/modules/shared/sliders/ProductCarousel.vue";
import { useAPI } from "~/uses/useMyFetch";
import { Product } from "~/models/product.model";

const products = ref(null);

onMounted(() => {
  useAPI("/catalog/product/list/seen", {
    params: {
      limit: 15,
    },
  }).then((data) => {
    products.value = data.map(({ product }) => new Product(product));
  });
});
</script>

<style lang="scss" scoped>
.slider-loader {
  @include flex-container(row, center, center);
}
</style>
